import { normalizeLocationText } from "../location/locationSearch.ts";

const ROOM_WORDS = new Map<string, number>([
  ["jednoizbovy", 1],
  ["dvojizbovy", 2],
  ["trojizbovy", 3],
  ["stvorizbovy", 4],
  ["patizbovy", 5],
  ["sestizbovy", 6],
  ["sedemizbovy", 7],
  ["osemizbovy", 8],
  ["devatizbovy", 9],
  ["desatizbovy", 10]
]);

const ROOM_QUERY_WORDS: Record<number, string> = {
  1: "jednoizbový",
  2: "dvojizbový",
  3: "trojizbový",
  4: "štvorizbový",
  5: "päťizbový",
  6: "šesťizbový",
  7: "sedemizbový",
  8: "osemizbový",
  9: "deväťizbový",
  10: "desaťizbový"
};

export const normalizeRoomCount = (value: unknown): number | undefined => {
  if (typeof value === "number") {
    return Number.isFinite(value) && value > 0 ? value : undefined;
  }
  if (typeof value !== "string") return undefined;

  const normalized = normalizeLocationText(value)
    .replace(/[‐‑‒–—]/g, "-")
    .replace(/\s+/g, " ");
  if (!normalized) return undefined;

  for (const [word, count] of ROOM_WORDS) {
    if (normalized.replace(/[\s-]+/g, "").includes(word)) return count;
  }

  const numeric = normalized.match(/(?:^|\b)(\d+(?:[.,]\d+)?)\s*-?\s*(?:izb(?:ovy|ova|ove)?\.?|i)(?=\s|\b|$)/);
  if (!numeric) return undefined;
  const count = Number(numeric[1].replace(",", "."));
  return Number.isFinite(count) && count > 0 ? count : undefined;
};

export const roomSearchVariants = (value: unknown): string[] => {
  const count = normalizeRoomCount(value);
  if (count === undefined) return [];
  const display = Number.isInteger(count) ? String(count) : String(count).replace(".", ",");
  const variants = [
    `${display} izbový`,
    `${display}-izbový`,
    `${display} izb.`,
    `${display}-izb.`,
    `${display}izbový`,
    `${display}i`
  ];
  if (Number.isInteger(count) && ROOM_QUERY_WORDS[count]) variants.push(ROOM_QUERY_WORDS[count]);
  return [...new Set(variants)];
};

export const canonicalRoomLabel = (value: unknown) => {
  const count = normalizeRoomCount(value);
  return count === undefined ? "" : `${Number.isInteger(count) ? count : String(count).replace(".", ",")}-izbový`;
};
